import {Component, Injector} from "@angular/core";
import {AppComponentBase} from "../../services/AppComponentBase";
import {ShowProviderConnectionModal} from "../modals/providerConnection/show-provider-connection-modal";
import {ShowOpenLiveAccountModal} from "../modals/open-live-account/open-live-account.component";

@Component({
    selector: "supportTools",
    template: require('./supportTools.component.html'),
    styles: [
        require('./supportTools.component.css')
    ]
})

export class SupportTools extends AppComponentBase {
    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    openProviderConnection() {
        if(!this.workspaceService.data.LoginModalCreated) {
            ShowProviderConnectionModal(this.modalService, this.workspace.mobileMode);
        }
    }

    openLiveAccountModal() {
        if(!this.workspaceService.data.LoginModalCreated) {
            ShowOpenLiveAccountModal(this.modalService).modeOpen = true;
        }
    }

    withdrawalLiveAccountModal() {
        if(!this.workspaceService.data.LoginModalCreated) {
            ShowOpenLiveAccountModal(this.modalService).modeOpen = false;
        }
    }


    public get debugVisibility() {
        return this.workspace.debugVisibility
    }

}